module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/product_detail/sample_cover-c96680715f1fdb4bf846ec0e98d4f5a6.png";